export const adap_pedido_pago = (pedido) => {


    const obtenerItems = (productos) =>{


        let arr = []

        let obj ={
            "id": 'envio',
            "title": `Envio a ${pedido.provincia}`,
            "description": `${pedido.provincia} - ${pedido.direccion}`,
            "category_id": 'servicios',
            "quantity": 1,
            "currency_id": "ARS",
            "unit_price": parseInt(pedido.valorEnvio),
        }

        arr.push(obj)

        for(let producto of productos){
            let obj ={
                "id": producto.id,
                "title": producto.nombre,
                "description": producto.descripcion,
                "category_id": producto.categoria,
                "quantity": parseInt(producto.cantidad),
                "currency_id": "ARS",
                "unit_price": parseInt(producto.valor),
            }
            arr.push(obj)
        }

        return arr

    }


    let obj = {
        "items": obtenerItems(pedido.productos),
        "payer": {
            "name": pedido.nombres,
            "surname": pedido.apellidos,
            "email": pedido.correo,
            "phone": {
                "area_code": "54",
                "number": pedido.celular
            },
            "identification": {
                "type": "DNI",
                "number": pedido.cc
            },
            "address": {
                // "zip_code": "110221",
                // "street_name": "Example Street",
                // "street_number": 93
            },
            "external_reference":pedido.id
        }
    }

    return obj


}